
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import { Link } from "react-router-dom";
import "./FAQ.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllFAQs } from "../../Redux/Actions/faqsAction";
import LottieAnimation from "../../Animations/LottieAnimation";
import { Dropdown, Menu, Button } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Modal } from "antd";
import { updateFAQ } from "../../Redux/Actions/faqsAction";

const FAQ = () => {

    const dispatch = useDispatch();
    const { data, success, loading } = useSelector((state) => state.faq)
    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedFAQ, setSelectedFAQ] = useState(null);
    const [editMode, setEditMode] = useState(false);

    const handleView = (record) => {
        setSelectedFAQ(record);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setEditMode(false);
        setIsModalVisible(false);
        setSelectedFAQ(null);
    };
    const handleEdit = (record) => {
        setSelectedFAQ(record);
        setEditMode(true)
        setIsModalVisible(true);
    }
    const columnsPages = [
        {
            title: "Sr.No.",
            align: "center",
            key: "srno",
            render: (_, __, index) => index + 1,
        },
        {
            title: "Created Date",
            align: "center",
            dataIndex: "created_at",
            key: "created_at",
        },
        {
            title: "Question",
            align: "center",
            dataIndex: "question",
            key: "title",
        },

        {
            title: "Answer",
            align: "center",
            dataIndex: "answer",
            key: "type",
        },
        {
            title: "Action",
            align: "center",
            key: "action",
            render: (_, record) => {
                const menu = (
                    <Menu>
                        <Menu.Item key="view" onClick={() => handleView(record)}>
                            View
                        </Menu.Item>
                        <Menu.Item key="edit" onClick={() => handleEdit(record)}>
                            Edit
                        </Menu.Item>
                    </Menu>
                );
                return (
                    <Dropdown overlay={menu} trigger={['click']}>
                        <Button icon={<EllipsisOutlined />} />
                    </Dropdown>
                );
            },
        },
    ];
    const dataSource = Array.isArray(data?.data)
        ? data?.data?.map((item, index) => ({
            key: item?._id,
            _id: item?._id,
            created_at: item?.created_at?.split("T")[0] || "N/A",
            question: item?.question || "No Question",
            answer: item?.answer || "No Answer",
        }))
        : [];
    useEffect(() => {
        dispatch(getAllFAQs())
    }, [])
    if (loading) {
        return (
            <LottieAnimation />
        )
    }
    return (
        <MainLayout>
            <div className="faq_table_container">
                <div className="h1_button">
                    <h1>Pages</h1>
                    {canAdd &&
                        <Link to="/faq/addFQ">
                            <button className="add_pages_button">Add FAQs</button>
                        </Link>
                    }
                </div>
                <Table dataSource={dataSource} columns={columnsPages}></Table>
                <Modal
                    title={editMode ? "Edit FAQ" : "View FAQ"}
                    visible={isModalVisible}
                    onCancel={handleModalClose}
                    footer={null}
                >
                    {selectedFAQ && (
                        <div className="faq-modal-content">
                            {!editMode && (<div className="faq-field">
                                <span className="faq-label">Created Date:</span>
                                <span className="faq-value">{selectedFAQ.created_at}</span>
                            </div>)}

                            <div className="faq-field">
                                <span className="faq-label">Question:</span>
                                {editMode ? (
                                    <textarea
                                        className="input-class"
                                        value={selectedFAQ.question}
                                        onChange={(e) =>
                                            setSelectedFAQ({ ...selectedFAQ, question: e.target.value })
                                        }
                                        rows={3}
                                        placeholder="Enter question"
                                    />
                                ) : (
                                    <span className="faq-value">{selectedFAQ.question}</span>
                                )}
                            </div>

                            <div className="faq-field">
                                <span className="faq-label">Answer:</span>
                                {editMode ? (
                                    <textarea
                                        className="input-class"
                                        value={selectedFAQ.answer}
                                        onChange={(e) =>
                                            setSelectedFAQ({ ...selectedFAQ, answer: e.target.value })
                                        }
                                        rows={3}
                                        placeholder="Enter answer"
                                    />
                                ) : (
                                    <span className="faq-value">{selectedFAQ.answer}</span>
                                )}
                            </div>

                            {editMode && (
                                <div className="modal-buttons" style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    <Button type="primary" onClick={() => {

                                        dispatch(updateFAQ({
                                            id: selectedFAQ._id,
                                            question: selectedFAQ.question,
                                            answer: selectedFAQ.answer
                                        }
                                        ));
                                        setIsModalVisible(false);
                                        setEditMode(false);
                                    }}>
                                        Save
                                    </Button>
                                    <Button onClick={handleModalClose}>Cancel</Button>
                                </div>
                            )}
                        </div>
                    )}
                </Modal>
            </div>
        </MainLayout>
    )
}
export default FAQ
